export class OOPriceLevel {
	priceLevelKey: number;
	name: string;
	priceName1: string;
	priceName2: string;
	priceName3: string;
	priceName4: string;
	priceName5: string;
	priceName6: string;
	priceDisplayName1: string;
	priceDisplayName2: string;
	priceDisplayName3: string;
	priceDisplayName4: string;
	priceDisplayName5: string;
	priceDisplayName6: string;

	public constructor(init?: Partial<OOPriceLevel>) {
		Object.assign(this, init);
	}
}
